import {Component, OnInit} from '@angular/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EnvironmentService} from '../../services/environment.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MyBusiness} from '../../models/my-business';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {CommonModule} from '@angular/common';
import {SettingsButtonWidgetComponent} from '../settings-button-widget/settings-button-widget.component';

@Component({
  selector: 'app-settings-list',
  templateUrl: './settings-list.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, SettingsButtonWidgetComponent, RouterModule],
  styleUrls: ['./settings-list.component.scss']
})
export class SettingsListComponent implements OnInit {
  myBusiness: MyBusiness;
  lang: any;
  loading: any;
  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;

  checkPermission() {
    let perms = this.env.checkPermission(this.myBusiness.subAccountType, this.myBusiness.subAccountGovId);
    this.isAccountant = perms.isAccountant;
    this.isSales = perms.isSales;
    this.isManager = perms.isManager;
  }

  constructor(private loader: GlobalLoaderService,
              private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private translate: TranslateService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.loading = true;
    this.myBusiness = await this.api.getMyBusiness(false);
    this.checkPermission();
    setTimeout(async () => {
      this.loading = false;
      this.lang = await firstValueFrom(this.translate.get('lang'));
    }, 1000);
  }

}
